"use client";
import React from "react";
//#region packages/@mantine/core/src/core/utils/get-ref-prop/get-ref-prop.ts
function getRefProp(element) {
	const version = React.version;
	if (typeof React.version !== "string") return element?.ref;
	if (version.startsWith("18.")) return element?.ref;
	return element?.props?.ref;
}
//#endregion
export { getRefProp };

//# sourceMappingURL=get-ref-prop.mjs.map